import { createUseStyles } from "react-jss";

/**
 * Styles for the user profile page
 */
export const useProfilePageStyles = createUseStyles({
  mainContentCls: {
    padding: "2em"
  },
  titleCls: {
    fontSize: "20px",
    fontWeight: "bold"
  }
});
